<app-navigation></app-navigation>
<div class="row">&nbsp; </div>
<app-file-upload></app-file-upload>
<div class="row">&nbsp; </div>
<div class="container">
    <div class="row">
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button type="submit" class="btn btn-success mr-2" (click)="submitClaim('Submitted')">Submit Claim</button>
    </div>
</div>